import React from "react";
import classnames from "classnames";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import { trackMonetateEvent } from "../../../context/MonetateContext";
import ContactMethodsList from "./contact-methods-list/ContactMethodsList";
import styles from "./contact-methods.module.scss";

function ContactMethods({
  newDesign = false,
  fields = [],
  solutionId = null,
  location,
  contactDetails = {},
  viewContactDetails = false,
  showGreyBackground = false,
  showEmailOption,
}) {
  let sortedFields = fields;
  const isChatAvailable = fields.some(field => field.name === "chat");
  if (isChatAvailable) {
    sortedFields = [...fields].sort((a, b) => (a.name === "chat") - (b.name === "chat")).reverse();
  }

  const handleEmailClick = () => {
    trackMonetateEvent("email_contact_rate");
  };

  return (
    <div className={classnames(styles.cm, fields.length === 1 ? styles.oneItem : null)}>
      <div className={styles.cm__subheader}>
        {viewContactDetails ? "Choose how you’d like to contact us" : "Find the best way to contact us below."}
      </div>
      <ContactMethodsList
        fields={sortedFields}
        newDesign={newDesign}
        solutionId={solutionId}
        location={location}
        contactDetails={contactDetails}
        isChatSupported
        showGreyBackground={showGreyBackground}
      />
      {contactDetails.email?.open && showEmailOption ? (
        <p className={classnames(styles.cm__email, styles.cm_livechatprominent)}>
          Live chat or calling us is usually the quickest way to get help. Our{" "}
          <Link href={getEmailUsUrl(location)} data-test="email-us-link" onClick={handleEmailClick}>
            contact form
          </Link>{" "}
          is available, though it can take a little longer for us to come back to you.
        </p>
      ) : null}
    </div>
  );
}

export default ContactMethods;
